import { GridColDef } from '@mui/x-data-grid';
import { IntlShape } from 'react-intl';
import { ConsumptionTableAllRecordType, ConsumptionTableByProductByUserType } from '@shared/entity';
import DateButton from './DateButton';
import QuantityPriceCell from './QuantityPriceCell';
import UserCell from './UserCell';
import TotalPriceCell from './TotalPriceCell';

export const createColumnsByProduct = (
  intl: IntlShape,
  currency: string,
): GridColDef<ConsumptionTableByProductByUserType[][number]>[] => [
  {
    field: 'stockItemName',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Položka',
      id: 'consumption.item',
    })}`,
    flex: 4,
    disableColumnMenu: true,
    minWidth: 100,
  },
  {
    field: 'totalQuantity',
    headerName: `${intl.formatMessage({
      defaultMessage: `Množ./${currency}`,
      id: 'consumption.quantityPrice',
    })}`,
    flex: 4,
    minWidth: 70,
    disableColumnMenu: true,
    renderCell: params => (
      <QuantityPriceCell
        value={params.value}
        unit={params.row.unit}
        totalPrice={params.row.totalPrice}
        type={params.row.type}
      />
    ),
  },
  {
    field: 'user',
    flex: 4,
    headerName: `${intl.formatMessage({
      defaultMessage: 'Kdo',
      id: 'consumption.person',
    })}`,
    disableColumnMenu: true,
    display: 'flex',
    renderCell: params => <UserCell userName={params.value} />,
  },
];

export const createColumnsByUser = (
  intl: IntlShape,
  _currency?: string,
): GridColDef<ConsumptionTableByProductByUserType[][number]>[] => [
  {
    field: 'user',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Kdo',
      id: 'consumption.person',
    })}`,
    flex: 6,
    disableColumnMenu: true,
    display: 'flex',
    renderCell: params => <UserCell userName={params.value} />,
  },
  {
    field: 'totalQuantity',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Celkem',
      id: 'consumption.totalQuantity',
    })}`,
    minWidth: 70,
    flex: 6,
    disableColumnMenu: true,
    renderCell: params => <TotalPriceCell totalPrice={params.row.totalPrice} />,
  },
];

export const createColumnsAllRecords = (
  navigate: (path: string) => void,
  intl: IntlShape,
  currency = 'CZK',
): GridColDef<ConsumptionTableAllRecordType[][number]>[] => [
  {
    field: 'date',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Datum',
      id: 'consumption.date',
    })}`,
    flex: 3,
    disableColumnMenu: true,
    minWidth: 40,
    renderCell: params => (
      <DateButton
        visitDate={params.row.visitDate}
        clientId={params.row.clientId}
        visitId={params.row.visitId}
        navigate={navigate}
      />
    ),
  },
  {
    field: 'stockItemName',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Položka',
      id: 'consumption.item',
    })}`,
    flex: 3,
    disableColumnMenu: true,
    minWidth: 100,
  },
  {
    field: 'stockAllowanceQuantity',
    headerName: `${intl.formatMessage({
      defaultMessage: `Množ./${currency}`,
      id: 'consumption.quantityPrice',
    })}`,
    flex: 3,
    minWidth: 40,
    disableColumnMenu: true,
    renderCell: params => (
      <QuantityPriceCell
        value={params.value}
        unit={params.row.unit}
        totalPrice={params.row.totalPrice}
        type={params.row.type}
      />
    ),
  },
  {
    field: 'user',
    headerName: `${intl.formatMessage({
      defaultMessage: 'Kdo',
      id: 'consumption.person',
    })}`,
    flex: 3,
    disableColumnMenu: true,
    display: 'flex',
    renderCell: params => <UserCell userName={params.value} />,
  },
];
